<template>
  <span v-if="price" class="price-label float-right">
    <span v-if="price == 0">
      免费
    </span>
    <span v-if="price > 0"> ${{ formatPrice(price) }} </span>
  </span>
</template>

<script>
export default {
  props: {
    price: {
      required: true
    }
  },
  methods: {
    formatPrice(val) {
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }
};
</script>
